import React from 'react';
import { Form, Icon, Message} from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoDpto} value={props.elemento._id}>{props.elemento.descrDpto}</option>
  )
};

const Lista = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="dpto" id="miLista" value={permiteUpdate?argsDocum._id:idLista._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivel3 = props => {
  return(
    <option dato1={props.elemento.codigoCiudad} value={props.elemento.codigoCiudad}>{props.elemento.nombreCiudad}</option>
  )
}

const DetalleNivel2 = ({styles, idLista, argsDocum, elemento, permiteUpdate, handleChange}) => {
  const Nivel3Detalle = elemento.ciudades.map((elemento, i) => <DetalleNivel3 styles={styles} elemento={elemento} key={i} />);
  return (
    <select className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" value={permiteUpdate?argsDocum.codigoCiudad:idLista.codigoCiudad} onChange={(ev)=>handleChange(ev, argsDocum)}>
      {Nivel3Detalle}
    </select>
  )
};

const ListaCi = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  var Nivel2Detalle = []
  list.forEach((elemento, _id) => {
    if(elemento._id===idLista._id){
      let niv2Det = []
      niv2Det.push(elemento)
      Nivel2Detalle = niv2Det.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} permiteUpdate={permiteUpdate} idLista={idLista} argsDocum={argsDocum} handleChange={handleChange}/>);
    }
  })
  return(
    <div>
      {Nivel2Detalle}
    </div>
  )
};

class VerZon2 extends React.Component {
  state={
    argsDocum: {codigoZona: this.props.idLista.codigoZona,
                nombreZona: this.props.idLista.nombreZona,
                nombreZonaAnt: this.props.idLista.nombreZona,
                codigoCiudad: this.props.idLista.codigoCiudad,
                nombreCiudad: this.props.idLista.nombreCiudad,
                codigoDpto: this.props.idLista.codigoDpto,
                descrDpto: this.props.idLista.descrDpto,
                _id: this.props.idLista._id},
    confirmaAct: false,
    open: false
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      // console.log(ev.target.name)
      // console.log(ev.target)
      if(ev.target.name !== "codigoZona"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "dpto"){
//No se permite modificar el departamento => se comentan las lineas siguientes
          // argsDocum['_id'] = ev.target.value
          // var miLista = document.getElementById("miLista");
          // argsDocum['descrDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
        }else{
          argsDocum[ev.target.name] = ev.target.value 
        }
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, confirmaAct, open} = this.state;

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large hand point down yellow icon"></i>
            Zona
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Código</label>
                    <Form.Input autoComplete="off" name="codigoZona" id="codigoZona" value={argsDocum.codigoZona} onChange={this.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoZona'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="nombreZona" id="nombreZona" value={this.props.permiteUpdate?argsDocum.nombreZona:this.props.idLista.nombreZona} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nombreZona'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Departamento</label>
                    <Lista list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Ciudad</label>
                    <ListaCi list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>

                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>

                  {
                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerZon2
